<script>
    import {Line, mixins} from 'vue-chartjs';

    const {reactiveProp} = mixins;

    var timeFormat = 'h a, D MMM YYYY';

    export default {
        extends: Line,
        name: "TweetHistogram",
        mixins: [reactiveProp],
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        legend: {
                            display: false
                        },
                        scales: {
                            xAxes: [{
                                type: 'time',
                                time:{
                                    unit: 'hour',
                                    displayFormats:{
                                        hour: timeFormat,
                                    },
                                    tooltipFormat: timeFormat,
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: "Date & Time"
                                }

                            }],
                            yAxes: [{
                                scaleLabel: {
                                    display: true,
                                    labelString: "Posts"
                                }
                            }]

                        }
                    }

                }
            }
        },
        data: function () {
            return {}
        },
        mounted() {
            this.renderChart(this.chartData, this.options);
        }

    }
</script>

<style scoped>

</style>
